/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseBannerFeldStil } from './DatabaseBannerFeldStil';
import {
    DatabaseBannerFeldStilFromJSON,
    DatabaseBannerFeldStilFromJSONTyped,
    DatabaseBannerFeldStilToJSON,
} from './DatabaseBannerFeldStil';

/**
 * Acht benannte Eigenschaften statt einer freien Zuordnung: So steht im
 * Schema, welche Felder es gibt, und ein Tippfehler faellt beim Erzeugen
 * des Clients auf — nicht erst dem Betreiber.
 * @export
 * @interface DatabaseBannerStile
 */
export interface DatabaseBannerStile {
    /**
     * 
     * @type {DatabaseBannerFeldStil}
     * @memberof DatabaseBannerStile
     */
    bild?: DatabaseBannerFeldStil;
    /**
     * 
     * @type {DatabaseBannerFeldStil}
     * @memberof DatabaseBannerStile
     */
    badge?: DatabaseBannerFeldStil;
    /**
     * 
     * @type {DatabaseBannerFeldStil}
     * @memberof DatabaseBannerStile
     */
    ueberschrift?: DatabaseBannerFeldStil;
    /**
     * 
     * @type {DatabaseBannerFeldStil}
     * @memberof DatabaseBannerStile
     */
    text?: DatabaseBannerFeldStil;
    /**
     * 
     * @type {DatabaseBannerFeldStil}
     * @memberof DatabaseBannerStile
     */
    zielgruppe?: DatabaseBannerFeldStil;
    /**
     * 
     * @type {DatabaseBannerFeldStil}
     * @memberof DatabaseBannerStile
     */
    label?: DatabaseBannerFeldStil;
    /**
     * 
     * @type {DatabaseBannerFeldStil}
     * @memberof DatabaseBannerStile
     */
    button?: DatabaseBannerFeldStil;
    /**
     * 
     * @type {DatabaseBannerFeldStil}
     * @memberof DatabaseBannerStile
     */
    icon?: DatabaseBannerFeldStil;
}

/**
 * Check if a given object implements the DatabaseBannerStile interface.
 */
export function instanceOfDatabaseBannerStile(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseBannerStileFromJSON(json: any): DatabaseBannerStile {
    return DatabaseBannerStileFromJSONTyped(json, false);
}

export function DatabaseBannerStileFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBannerStile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bild': !exists(json, 'bild') ? undefined : DatabaseBannerFeldStilFromJSON(json['bild']),
        'badge': !exists(json, 'badge') ? undefined : DatabaseBannerFeldStilFromJSON(json['badge']),
        'ueberschrift': !exists(json, 'ueberschrift') ? undefined : DatabaseBannerFeldStilFromJSON(json['ueberschrift']),
        'text': !exists(json, 'text') ? undefined : DatabaseBannerFeldStilFromJSON(json['text']),
        'zielgruppe': !exists(json, 'zielgruppe') ? undefined : DatabaseBannerFeldStilFromJSON(json['zielgruppe']),
        'label': !exists(json, 'label') ? undefined : DatabaseBannerFeldStilFromJSON(json['label']),
        'button': !exists(json, 'button') ? undefined : DatabaseBannerFeldStilFromJSON(json['button']),
        'icon': !exists(json, 'icon') ? undefined : DatabaseBannerFeldStilFromJSON(json['icon']),
    };
}

export function DatabaseBannerStileToJSON(value?: DatabaseBannerStile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bild': DatabaseBannerFeldStilToJSON(value.bild),
        'badge': DatabaseBannerFeldStilToJSON(value.badge),
        'ueberschrift': DatabaseBannerFeldStilToJSON(value.ueberschrift),
        'text': DatabaseBannerFeldStilToJSON(value.text),
        'zielgruppe': DatabaseBannerFeldStilToJSON(value.zielgruppe),
        'label': DatabaseBannerFeldStilToJSON(value.label),
        'button': DatabaseBannerFeldStilToJSON(value.button),
        'icon': DatabaseBannerFeldStilToJSON(value.icon),
    };
}

